<template>
    <component :is="componentTag" />
  </template>
  <script>
  import webDownload from "./web";
  import mobileDownload from "./mobile";
  export default {
    components: {
      webDownload,
      mobileDownload,
    },
    data() {
      return {
        isMobile: false,
        componentTag: "",
      };
    },
    created() {
      this.listenObserverWidth(750);
    },
    methods: {
      // 监听可视窗口宽度
      listenObserverWidth(mobileWidth) {
        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (entry.contentRect.width <= mobileWidth) {
              this.componentTag = "mobileDownload";
            } else {
              this.componentTag = "webDownload";
            }
          }
        });
        resizeObserver.observe(document.body);
      },
    },
  };
  </script>